function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGruppe2964(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Gruppe 2964",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 158.371,
    viewBox: "0 0 120 158.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2ckq8inlha"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2577",
    style: {
      fill: "none"
    },
    d: "M0 0h120v158.371H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2963",
    style: {
      clipPath: "url(#2ckq8inlha)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2880",
    d: "M114.2 19.924a45.8 45.8 0 1 1-64.168-8.791 45.8 45.8 0 0 1 64.168 8.791",
    transform: "translate(-5.046 -.287)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2881",
    d: "M114.2 19.924a45.8 45.8 0 1 1-64.168-8.791 45.8 45.8 0 0 1 64.168 8.791z",
    transform: "translate(-5.046 -.287)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#c5d75d",
      strokeWidth: "3.626px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2882",
    d: "M76.6 33.523a15.961 15.961 0 0 0 .711 30.731l1.75 5.732 15.86-4.84-1.75-5.732A15.961 15.961 0 0 0 76.6 33.523M90.827 58.19l-.529.541 1.442 4.725-10.994 3.354-1.441-4.725-.741-.153a13.417 13.417 0 1 1 12.263-3.742",
    transform: "translate(-10.321 -5.189)",
    style: {
      fill: "#c5d75d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2883",
    d: "m84.286 84.726 15.863-4.841-2.256-7.391-15.863 4.842zm.92-5.7 11-3.356.77 2.523-11 3.357z",
    transform: "translate(-12.967 -11.46)",
    style: {
      fill: "#c5d75d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2884",
    d: "M87.634 88.856a5.782 5.782 0 0 0 7.208 3.837l1.514-.462a5.78 5.78 0 0 0 3.835-7.208l-.571-1.871-12.557 3.834zm10.243-2.511a3.232 3.232 0 0 1-2.264 3.455l-1.513.46a3.233 3.233 0 0 1-3.808-1.6z",
    transform: "translate(-13.763 -13.145)",
    style: {
      fill: "#c5d75d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2572",
    transform: "rotate(-16.969 77.169 -191.651)",
    style: {
      fill: "#c5d75d"
    },
    d: "M0 0h5.089v10.657H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2573",
    transform: "rotate(-16.969 159.393 -283.198)",
    style: {
      fill: "#c5d75d"
    },
    d: "M0 0h10.657v5.089H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2574",
    transform: "rotate(-16.973 184.713 -113.268)",
    style: {
      fill: "#c5d75d"
    },
    d: "M0 0h10.656v5.089H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2575",
    transform: "rotate(-61.973 47.114 -20.403)",
    style: {
      fill: "#c5d75d"
    },
    d: "M0 0h5.088v10.658H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2576",
    transform: "rotate(-61.983 59.067 -53.317)",
    style: {
      fill: "#c5d75d"
    },
    d: "M0 0h10.656v5.088H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2885",
    d: "M55.775 162.241A10.12 10.12 0 1 0 65.9 172.36a10.13 10.13 0 0 0-10.12-10.119",
    transform: "translate(-7.217 -25.647)",
    style: {
      fill: "#c5d75d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2886",
    d: "M55.775 162.241A10.12 10.12 0 1 0 65.9 172.36a10.13 10.13 0 0 0-10.125-10.119z",
    transform: "translate(-7.217 -25.647)",
    style: {
      stroke: "#3e4346",
      strokeWidth: "3.649px",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2887",
    d: "M95.867 162.241a10.12 10.12 0 1 0 10.12 10.119 10.13 10.13 0 0 0-10.12-10.119",
    transform: "translate(-13.555 -25.647)",
    style: {
      fill: "#c5d75d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2888",
    d: "M95.867 162.241a10.12 10.12 0 1 0 10.12 10.119 10.13 10.13 0 0 0-10.12-10.119z",
    transform: "translate(-13.555 -25.647)",
    style: {
      stroke: "#3e4346",
      strokeWidth: "3.649px",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2889",
    d: "m112.461 94.083-.006-.006a5.729 5.729 0 0 0-4.288-1.845H30.111l-3-9.978a5.455 5.455 0 0 0-5.316-3.67H5.511a5 5 0 1 0 0 9.952h12.071l15.293 50.927a5.459 5.459 0 0 0 5.316 3.667h57.681a5.45 5.45 0 0 0 5.313-3.669l12.3-40.945a4.634 4.634 0 0 0-1.023-4.432",
    transform: "translate(0 -12.422)",
    style: {
      fill: "#3e4346"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2890",
    d: "M113.213 109.716h-82.72l6.67 22.221 3.472 11.563a2.425 2.425 0 0 0 2.377 1.479h57.681a2.407 2.407 0 0 0 2.37-1.479l2.962-9.857z",
    transform: "translate(-4.82 -17.344)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2891",
    d: "m111.12 98.209-1.228 4.089H25.327L20.445 86.04H6.088a2.251 2.251 0 0 1-2.439-1.9 2.226 2.226 0 0 1 2.439-1.9h16.286a2.415 2.415 0 0 1 2.373 1.478L28.4 95.881h80.343a2.7 2.7 0 0 1 2 .822 1.571 1.571 0 0 1 .378 1.506",
    transform: "translate(-.577 -12.999)",
    style: {
      fill: "#c5d75d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGruppe2964);
export default __webpack_public_path__ + "static/media/gruppe-2964.21537217e346315fc4fb790a8f612e9b.svg";
export { ForwardRef as ReactComponent };